import React, { Component } from 'react';
import { Modal } from 'antd';

class ThankModal extends Component {
    render() {
        const { visible, onCancel } = this.props;

        return (
            <div>
                <Modal
                    visible={visible}
                    footer={null}
                    onCancel={onCancel}
                >
                    <h1 style={{ textAlign: 'center' }}>
                        Thank You!
                    </h1>
                </Modal>
            </div>
        );
    }
}

export default ThankModal;



// WEBPACK FOOTER //
// ./src/component/MsgOptPage/ThankModal.js